import Icon from "./Icon";
import Text from "./Text";

interface INavItemProps {
    id: string;
    children: string;
    showPrefixIcon?: boolean;
    onSelectOption: (id: string) => void; 
}

export function NavItem({ id, children, showPrefixIcon, onSelectOption }: INavItemProps) {
    return (
        <li className="border-1 border-round border-gray-300 p-2">
            <a 
                className="cursor-pointer justify-content-between transition-colors transition-duration-200 flex hover:text-primary" 
                onClick={() => onSelectOption(id)}
            >
                {
                    showPrefixIcon && (
                        <Icon name="pi-angle-left" />
                    )
                }
                
                <Text fontWeight="light" color="800">{children}</Text>

                {
                    !showPrefixIcon && (
                        <Icon name="pi-angle-right" />
                    )
                }
            </a>
        </li>
    )
}

interface INavProps {
    children: React.ReactElement<typeof NavItem>[]|React.ReactElement<typeof NavItem>;
}

export default function Nav({ children }: INavProps) {
    return (
        <nav>
            <ul className="list-none p-0 flex gap-2 flex-column">
                {children}
            </ul>
        </nav>
    )
}